(function ($) {
    $.nette.ext('bs-modal', {
        init() {
            const self = this;

            this.ext('snippets', true).before($.proxy(($el) => {
                $el = $($el).find('> div.modal');
                if ($el.length === 0) {
                    return;
                }

                self.before();
            }, this));

            this.ext('snippets', true).after($.proxy(($el) => {
                $el = $($el).find('> div.modal');
                if ($el.length === 0) {
                    return;
                }

                self.after($el);
            }, this));

            $('[id^="snippet-"] > div.modal').each(function () {
                self.after($(this));
            });
        },
    }, {
        before() {
            const $opened = this.getOpened();

            if (!$opened) {
                return;
            }

            this.hide($opened);
        },
        after($modal) {
            if (this.isEmpty($modal)) {
                return; // ignore empty modal
            }
            this.show($modal);
            $modal.on('hidden.bs.modal', () => {
                this.removeModalFromUrl($modal.attr('id'));
            });
        },
        isEmpty(el) {
            const content = el.find('.modal-content');
            return !content.length;
        },
        removeModalFromUrl(modalId) {
            const currentUrl = window.location.href;

            const newUrl = currentUrl.replace(new RegExp(`&do=${modalId}-show|do=${modalId}-show&|do=${modalId}-show`), '').replace(new RegExp(/\?$/), '');

            window.history.replaceState({}, document.title, newUrl);
        },
        getOpened() {
            let $opened = $('.modal.show');

            if ($opened.length) {
                $opened = $opened.first();
            } else {
                $opened = null;
            }

            return $opened;
        },
        hide($modal) {
            $modal.modal('hide');
        },
        show($modal) {
            $modal.modal('show');
        },
    });
}(jQuery));
